export const LICENSE_SGA = 'SGA';
export const LICENSE_DGA = 'DGA';
export const LICENSE_DEGA = 'DEGA';
export const LICENSE_MGA = 'MGA';
export const LICENSE_PLGA = 'PLGA';
export const LICENSE_SHL = 'SHL';
export const LICENSE_KSA = 'KSA';
export const LICENSE_OGA = 'OGA';
